const NAME_SPLIT_REGEXP = /[\.-_]/g;

export const initialsFromEmail = (text = '') => {
  const user = text.split('@');
  const name = user[0].split(NAME_SPLIT_REGEXP);

  if (name.length > 1) {
    return name[0].slice(0, 1) + name[1].slice(0, 1);
  }

  return name[0].slice(0, 2);
};

export const initialsFromName = (text = '') => {
  const name = text.split(' ');

  if (name.length > 1) {
    return name[0].slice(0, 1) + name[1].slice(0, 1);
  }

  return name[0].slice(0, 2);
};

export const initialsFromText = (name = '', limit = 2) => {
  if (name.includes(' ')) {
    return name
      .split(' ')
      .map((word) => word[0])
      .slice(0, limit)
      .join('');
  }

  return name.slice(0, limit).toUpperCase();
};

export const nameFromEmail = (text = '') => {
  const user = text.split('@');
  const name = user[0].split(NAME_SPLIT_REGEXP);

  if (name.length > 1) {
    const [first, last] = name;

    return first.charAt(0).toUpperCase() + first.slice(1) + ' ' + last.charAt(0).toUpperCase() + last.slice(1);
  }

  return name[0].charAt(0).toUpperCase() + name[0].slice(1);
};

export const userMetadata = ({
  domainname,
  email,
  features,
  lastsignature,
  params: paramsArray = [],
  sigcompliance
}) => {
  let initials = '';
  let metadata = {};
  let photoUrl = '';

  if (paramsArray.length) {
    metadata = paramsArray
      .map((param) => ({ name: param.name, value: param.default }))
      .reduce((obj, params) => {
        obj[params.name] = params.value;
        return obj;
      }, {});

    if (metadata.name) {
      const [firstName, ...rest] = (metadata.name || '').split(' ');
      const lastName = rest.length ? rest[rest.length - 1][0] : firstName[1];

      initials = `${firstName[0]}${lastName}`;
    } else {
      metadata.name = nameFromEmail(email);
      initials = initialsFromEmail(email);
    }
  } else {
    metadata.name = nameFromEmail(email);
    initials = initialsFromEmail(email);
  }

  if (features) {
    if (features.includes('enablegappsphotos')) {
      photoUrl = `https://smart.${domainname}/photo/${email}/google.jpg`;
    }

    if (features.includes('enableo365photos')) {
      photoUrl = `https://smart.${domainname}/photo/${email}/office365.jpg`;
    }
  }

  return {
    ...metadata,
    email,
    initials,
    photoUrl,
    signatureLastSeen: lastsignature ? new Date(lastsignature) : null,
    signature: sigcompliance?.block || '',
    sigblock: sigcompliance,
    // this is used in the select component
    label: metadata.name || email,
    value: email
  };
};
